import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
/* eslint-disable */
// Dashboard
import Dashboard from '../views/Dashboard'

// Components
import CardFuncionarioProfile from '../components/views/Cards/FuncionarioProfile'
import CardEmpresas from '../components/views/Cards/Empresas.vue'
import CardEquipamentos from '../components/views/Cards/Equipamentos.vue'
import CardEstatisticas from '../components/views/Cards/Estatisticas.vue'
import Analises from '../components/views/Cards/Analises.vue'
import AnalysesDetails from '../components/views/Cards/AnalisesDetails.vue'
import CardImage from '../components/views/Cards/Image'
import CardClassificar from '../components/views/Cards/Classificar'
import CardAnalisesMelhorias from '../components/views/Cards/AnalisesMelhorias.vue'
import Home from '../components/views/Cards/Home.vue'

// Login
import Login from '../views/Login.vue'

// Password Reset
import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'

// Edit Profile
import Edit from '../views/EditProfile.vue'
import { hasTokenExpired } from '../auth'
import { DB_ROLES, normalizeRole } from '../constants'

// Empresas e equipamentos: apenas SuperAdmin e ReadOnly (UsuarioComum)
const RESTRICTED_TO_SUPERADMIN_OR_READONLY = {
  empresas: [DB_ROLES.SUPER_ADMIN, DB_ROLES.COMMON],
  equipamentos: [DB_ROLES.SUPER_ADMIN, DB_ROLES.COMMON]
}

// Métricas operacionais: SuperAdmin, Gerente e Usuário Comum (ReadOnly)
const OPERATIONAL_METRICS_ROLES = {
  melhorias: [DB_ROLES.SUPER_ADMIN, DB_ROLES.MANAGER, DB_ROLES.COMMON]
}

// String to Component
const components = {
  'Cards.Analises': Analises,
  'Cards.FuncionarioProfile': CardFuncionarioProfile,
  'Cards.Empresas': CardEmpresas,
  'Cards.Equipamentos': CardEquipamentos,
  'Cards.Estatisticas': CardEstatisticas,
  'Cards.Home': Home,
  'Cards.Image': CardImage,
  'Cards.Classificar': CardClassificar,
  'Cards.AnalysesDetails': AnalysesDetails,
  'Cards.AnalisesMelhorias': CardAnalisesMelhorias
}

Vue.use(VueRouter)

const dashboardTabs = []

// Generate dynamic routes for dashboard
store.state.dashboard.forEach(module => {
  const state = store.state[module]

  if (state.noView) return

  const path = state.root ? '/' : module

  const mainAction = state.actions

  // Recursive insertion
  function registerRoutes (actions, path, name) {
    actions.filter(a => a.event === 'link' || !a.event).forEach(action => {
      const pathRoute = path + (action.key ? '/' + action.key : '')
      const nameRoute = name + (action.key ? '-' + action.key : '')
      const paramsRoute = (action.params ? '/' + action.params.map(p => ':' + p).join('/') : '')
      const fullPath = pathRoute + paramsRoute
      dashboardTabs.push(...[{
        path: fullPath,
        name: nameRoute,
        component: components[action.component],
        props: action.props
      }])
      if (action.children) {
        registerRoutes(action.children, fullPath /* pathRoute */, nameRoute)
      }
    })
  }
  registerRoutes([mainAction], path, module)
})

const routes = [
  // Dashboard
  {
    path: '/',
    component: Dashboard,
    children: [
      ...dashboardTabs,
      {
        path: 'classificar/:object_id',
        name: 'classificar',
        component: CardClassificar,
        props: true
      }
    ]
  },
  // Login
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters.isLogged) {
        next({ path: '/' })
        return
      }
      next()
    }
  },
  // Forgot Password
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { public: true }
  },
  // Reset Password
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { public: true }
  },
  // Edit
  {
    path: '/edit-profile',
    name: 'Edit',
    component: Edit,
    props: true
  },
  { path: '*', redirect: '/' } // Not Found
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Routes that don't require authentication
const publicRoutes = ['Login', 'ForgotPassword', 'ResetPassword']

router.beforeEach((to, from, next) => {
  // Allow access to public routes without authentication
  if (publicRoutes.includes(to.name) || to.meta?.public) {
    next()
    return
  }

  // For protected routes, check authentication
  if (!store.getters.isLogged || hasTokenExpired(store.state.token)) {
    store.dispatch('logout')
    next({ name: 'Login' })
    return
  }

  const roleRestrictions = {
    ...RESTRICTED_TO_SUPERADMIN_OR_READONLY,
    ...OPERATIONAL_METRICS_ROLES
  }
  const restrictedModule = Object.keys(roleRestrictions).find(module =>
    to.name === module || (typeof to.name === 'string' && to.name.startsWith(`${module}-`))
  )
  if (restrictedModule) {
    const allowedRoles = roleRestrictions[restrictedModule]
    const userRole = normalizeRole(store.getters.userRole || store.state.user?.userRole)
    if (!allowedRoles.includes(userRole)) {
      next({ path: '/' })
      return
    }
  }

  next()
})

export default router
